<template>
  <!-- video dialog -->
  <v-dialog
    v-model="isOpen"
    width="550px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-video-outline</v-icon>
          {{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertVideo.addEditVideo'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertVideo.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="beforeValidate">
          <!-- <v-row justify="center" class="rowContentmange"> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.videoName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                required
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.pleaseFillName'
                  )
                "
                v-model="title"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.details'
                  )
                }}
              </p>
              <v-textarea
                v-model="description"
                :label="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.details'
                  )
                "
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.pleaseFillDetails'
                  )
                "
                full-width
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.videoattachment'
                  )
                }}
                <span class="red--text">*</span>
                <span class="subtitle-1">{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.mp4'
                  )
                }}</span>
              </p>
              <v-file-input
                v-model="video_file"
                :rules="fileRules"
                counter
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertVideo.chooseFile'
                  )
                "
                outlined
                :show-size="1000"
                accept=".mp4"
                prepend-icon="mdi-video"
                @change="onFileChange"
              >
                <template v-slot:selection="{ index, text }">
                  <p class="mb-0">{{ text }}</p>
                  <!-- <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>{{ text }}</v-chip> -->

                  <span
                    v-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                    >+{{ files.length - 2 }} File(s)</span
                  >
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <!-- <v-row> -->
          <!-- <v-col class="examplePDF">
                          <v-label>ตัวอย่างหนังสือ</v-label>
                          <br />
                          <iframe
                            class="iframePDF"
                            src="https://s3-ap-southeast-1.amazonaws.com/s3.deknerd.com/pdfs/00+%E0%B8%8A%E0%B8%B5%E0%B8%A7%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2+%E0%B8%8A%E0%B8%B8%E0%B8%A1%E0%B8%9E%E0%B8%A3.pdf"
                          ></iframe>
          </v-col>-->
          <v-row align="center" justify="center">
            <v-col :lg="10" :md="12" :sm="12" :xs="12" v-if="successUpload">
              <v-row>
                <div v-if="successUpload" class="videoPlayer">
                  <video-player
                    v-if="!isCheckComplete && playerOptions.sources[0].src"
                    class="video-player-box videoContainer 2"
                    ref="videoPlayer"
                    :options="playerOptions"
                    :playsinline="true"
                    customEventName="customstatechangedeventname"
                  ></video-player>
                  <video-player
                    v-else-if="
                      isCheckComplete &&
                      antMediaServer &&
                      playerOptions.sources[0].src
                    "
                    class="video-player-box videoContainer"
                    ref="videoPlayer"
                    :options="playerOptions"
                    :playsinline="true"
                    customEventName="customstatechangedeventname"
                  ></video-player>
                  <iframe
                    v-if="isCheckComplete && !antMediaServer"
                    :src="`${urlVideo}`"
                    class="resonsive-iframe"
                    width="100%"
                    height="250"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-row>
            </v-col>
            <v-col
              :lg="10"
              :md="12"
              :sm="12"
              :xs="12"
              v-if="successUpload === false"
            >
              <v-row>
                <v-col :lg="12" :md="12" :sm="12" :xs="12">
                  <div class="container-preview">
                    <v-skeleton-loader
                      class="mx-auto"
                      width="100%"
                      type="card"
                      elevation="1"
                    ></v-skeleton-loader>
                    <div v-if="cantGetLink" class="progressContainerError">
                      <!-- <div>{{percent}}</div> -->
                      <v-alert type="error">{{
                        this.$vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertVideo.errorUploadAgain'
                        )
                      }}</v-alert>
                      <div></div>
                    </div>
                    <div
                      v-if="
                        showUploadPercent === false && cantGetLink === false
                      "
                      class="progressContainer"
                    >
                      <!-- <div>{{percent}}</div> -->
                      <v-icon x-large>play_circle_outline</v-icon>
                    </div>
                    <div
                      v-if="showUploadPercent == true"
                      class="progressContainer"
                    >
                      <!-- <div>{{percent}}</div> -->
                      <v-progress-linear
                        v-model="progressPercent"
                        height="25"
                        reactive
                      >
                        <strong>{{ progressPercent }}%</strong>
                      </v-progress-linear>
                      <div class="timeLeft">{{ timeLeft }}</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertVideo.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="beforeValidate"
          :loading="loadingBtn"
          :disabled="!isValid()"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertVideo.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import 'video.js/dist/video-js.css';
import $ from 'jquery';
import { videoPlayer } from 'vue-video-player';
// import { headersWithTokenForImage, domain } from "@/service/configApi";
import {
  headersWithTokenForImage,
  serverName,
  fileServerEndpoint,
} from '@/service/configApi';
import { getPrivateVideo } from '@/service/upload/upload.js';
import { insertLecture, updateLecture } from '@/service/course/course.js';
import videojs from 'video.js';
window.videojs = videojs;

// hls plugin for videojs6
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');
import axios from 'axios';
import { generateVodTicket } from '../../../helper/vod';
import { EventBus } from '../../../event-bus';

export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  components: { videoPlayer },
  data() {
    return {
      loadingBtn: false,
      valid: true,
      maxWidth: '40%',
      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertVideo.pleaseFillName'
          ),
      ],
      // playerOptions: {
      //     // videojs options
      //     muted: true,
      //     language: 'en',
      //     playbackRates: [0.7, 1.0, 1.5, 2.0],
      //     sources: [{
      //       type: "video/mp4",
      //       src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
      //     }],
      //   },
      isCheckComplete: false,
      wasCheckComplete: false,
      playerOptions: {
        // videojs options
        fluid: true,
        height: '500',
        // width: '300',
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src:
              'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          },
        ],
        // poster: "/static/images/author.jpg"
      },

      title: '',
      description: '',

      video_file: null,
      duration: 0,
      videoUploadId: '',
      mediaType: 'VDO',
      fileName: '',
      videoFile: null,
      timeLeft: '',
      successUpload: false,
      pendingUpload: false,
      percent: '',
      progressPercent: 0,
      showUploadPercent: false,
      urlVideo:
        // "https://fleet.byteark.com/player?url=http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8",
        'http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8',
      isRequire: true,

      // Edit
      oldVideoId: '',
      oldVideoUrl: '',
      cantGetLink: false,

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,

      antMediaServer: true,
    };
  },
  mounted() {
    // this.initialize();
  },
  computed: {
    fileRules() {
      const rules = [];

      if (this.lectureId === undefined) {
        const rule = (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertVideo.chooseFile'
          );

        rules.push(rule);
      }

      if (this.lectureId === undefined) {
        const rule = (v) =>
          (v && v.size < 5000000000) ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertVideo.maxFileSize5GB'
          );
        // const rule = v => (v && v.size < 10) || "File size should be less than 1 GB!";

        rules.push(rule);
      }

      //update
      if (this.lectureId !== undefined) {
        const rule = (v) =>
          (v ? (v.size < 5000000000 ? true : false) : true) ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertVideo.maxFileSize5GB'
          );
        rules.push(rule);
      }

      return rules;
    },
  },

  watch: {
    // whenever question changes, this function will run
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          this.title = filterLecture.title;
          this.description = filterLecture.description;
          let resultLink = await getPrivateVideo(filterLecture.video[0]._id);
          this.isCheckComplete = resultLink.isCheckComplete;
          this.wasCheckComplete = resultLink.isCheckComplete;

          this.oldValue = filterLecture;

          if (resultLink.isCheckComplete) {
            // this.playerOptions.sources[0].src = resultLink.urllocalhost+`?token=${localStorage.getItem("x-session-token")}`;
            // this.urlVideo = resultLink.urllocalhost+`?token=${localStorage.getItem("x-session-token")}`;
            // this.oldVideoUrl = resultLink.urllocalhost+`?token=${localStorage.getItem("x-session-token")}`;
            if (resultLink.server == 'antMedia') {
              this.urlVideo = resultLink.url;
              this.oldVideoUrl = resultLink.url;
              this.antMediaServer = true;
              this.playerOptions.sources[0] = {
                src: resultLink.url,
                type: 'application/x-mpegURL',
              };
              this.playerOptions.sources[0].src = resultLink.url;
              this.playerOptions.sources[0].type = 'application/x-mpegURL';
              // this.playerOptions.sources[0].src = 'https://cdn-vod.nerdof.com/hls/,59b36767-1333-4753-a327-99301e906059_720p.mp4,59b36767-1333-4753-a327-99301e906059_480p.mp4,59b36767-1333-4753-a327-99301e906059_360p.mp4,.urlset/master.m3u8'
              this.playerOptions.hls = true;
              // let temp = this.playerOptions
              // this.playerOptions = null
              // this.playerOptions = temp
            } else {
              this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink.url}`;
              this.oldVideoUrl = `https://fleet.byteark.com/player?url=${resultLink.url}`;
              this.antMediaServer = false;
            }
          } else {
            // this.urlVideo = resultLink.url
            // this.oldVideoUrl = resultLink.url

            if (resultLink.server == 'antMedia') {
              this.playerOptions.sources[0] = {
                src: resultLink.urllocalhost,
                type: 'application/x-mpegURL',
              };
              this.urlVideo = resultLink.urllocalhost;
              this.oldVideoUrl = resultLink.urllocalhost;
              this.antMediaServer = true;
            } else {
              this.playerOptions.sources[0].src =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`;
              this.urlVideo =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`;
              this.oldVideoUrl =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`;
              this.antMediaServer = false;
            }
          }
          // this.playerOptions.sources[0].src = resultLink.urllocalhost+`?token=${localStorage.getItem("x-session-token")}&server=${serverName}`;
          // this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink.url}`;
          // this.urlVideo = resultLink.urllocalhost+`?token=${localStorage.getItem("x-session-token")}`;
          // this.oldVideoUrl = resultLink.urllocalhost+`?token=${localStorage.getItem("x-session-token")}`;
          this.oldVideoId = filterLecture.video[0]._id;
          // this.oldVideoUrl = `https://fleet.byteark.com/player?url=${resultLink}`;
          this.successUpload = true;
          this.isRequire = false;

          this.video_file = null;
          this.duration = 0;
          this.videoUploadId = '';
          this.mediaType = 'VDO';
          this.fileName = '';
          this.videoFile = null;
          this.timeLeft = '';
          this.pendingUpload = false;
          this.percent = '';
          this.progressPercent = 0;
          this.showUploadPercent = false;
          this.loadingBtn = false;
        } else {
          this.title = '';
          this.description = '';
          this.video_file = null;
          this.duration = 0;
          this.videoUploadId = '';
          this.mediaType = 'VDO';
          this.fileName = '';
          this.videoFile = null;
          this.timeLeft = '';
          this.successUpload = false;
          this.pendingUpload = false;
          this.percent = '';
          this.progressPercent = 0;
          this.showUploadPercent = false;
          this.urlVideo =
            'https=//fleet.byteark.com/player?url=http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8';
          this.isRequire = true;
          this.antMediaServer = false;
          // Edit
          this.oldVideoId = '';
          this.oldVideoUrl = '';
          this.loadingBtn = false;
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
        }
      } else {
        this.title = '';
        this.description = '';
        this.video_file = null;
        this.duration = 0;
        this.videoUploadId = '';
        this.mediaType = 'VDO';
        this.fileName = '';
        this.videoFile = null;
        this.timeLeft = '';
        this.successUpload = false;
        this.pendingUpload = false;
        this.percent = '';
        this.progressPercent = 0;
        this.showUploadPercent = false;
        this.urlVideo =
          'https=//fleet.byteark.com/player?url=http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8';
        this.isRequire = true;
        this.antMediaServer = false;
        // Edit
        this.oldVideoId = '';
        this.oldVideoUrl = '';
        (this.playerOptions = {
          // videojs options
          fluid: true,
          height: '500',
          // width: '300',
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          hls: false,
          sources: [
            {
              type: 'video/mp4',
              src: null,
            },
          ],
          // poster: "/static/images/author.jpg"
        }),
          (this.loadingBtn = false);
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      }
    },
  },
  methods: {
    // initialize() {
    //   let courseID = localStorage.getItem("editCourseID");
    //   if (courseID != null) {
    //     let params = {
    //       id: courseID
    //     };

    //     this.getCourseDetail(params);
    //     this.isEdit = true;
    //   }
    // },
    isValid() {
      // return this.valid && this.successUpload;
      return this.valid;
    },
    async setLoadingBtn() {
      this.loadingBtn = true;
    },
    async unsetLoadingBtn() {
      this.loadingBtn = false;
    },
    async beforeValidate() {
      await this.setLoadingBtn();
      if (this.videoFile != null) {
        this.successUpload = false;
        this.showUploadPercent = true;
        this.cantGetLink = false;
        await this.uploadFile(this.videoFile);
      } else {
        await this.validate();
      }
      await this.unsetLoadingBtn();
    },
    async validate() {
      this.warnningToSaveDialog = false;
      if (this.$refs.form.validate() && this.successUpload) {
        if (!this.lectureId) {
          await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: this.description,
            type: 'VDO',
            video: [this.videoUploadId],
          });

          // let newLectures = this.lectures.map(lecture => lecture._id);
          // newLectures.push(result._id);

          this.reload();
          this.closeDialog();

          EventBus.$emit('creditPoint.show');
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          // let y = {
          //   ...currentLecture,
          //   id: this.lectureId,
          //   title: this.title,
          //   description: this.description,
          //   type: "VDO",
          //   video: this.videoUploadId ? [this.videoUploadId] : [this.oldVideoId]}

          await updateLecture({
            ...currentLecture,
            id: this.lectureId,
            title: this.title,
            description: this.description,
            type: 'VDO',
            video: this.videoUploadId
              ? [this.videoUploadId]
              : [this.oldVideoId],
          });
        }
        this.closeLectureDialog();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async setOpenModal() {
      await this.$emit('update:isOpen', false);
    },
    async closeAllDialog() {
      await this.$emit('update:isOpen', false);
      await this.$emit('update:isLectureOpen', false);
    },
    async onFileChange(file) {
      var myVideos = [];

      window.URL = window.URL || window.webkitURL;

      if (file === undefined) {
        if (this.lectureId) {
          this.videoUploadId = this.oldVideoId;
          this.playerOptions.sources[0].src = this.oldVideoUrl;
          this.urlVideo = this.oldVideoUrl;
          this.isCheckComplete = this.wasCheckComplete;
          this.successUpload = true;
        }
        return;
      }
      if (file.size > 5000000000) return;

      this.successUpload = false;
      this.pendingUpload = true;
      this.videoFile = file;
      var fileURL = URL.createObjectURL(file);
      this.playerOptions.sources[0].src = fileURL; //add this

      myVideos.push(file);
      var video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = await function () {
        window.URL.revokeObjectURL(video.src);
        var duration = video.duration;
        myVideos[myVideos.length - 1].duration = duration;
        this.duration = parseInt(duration, 10) * 1000;
      }.bind(this);

      this.successUpload = true;
      this.pendingUpload = false;
      this.isCheckComplete = false;

      video.src = URL.createObjectURL(file);
    },
    timeToString(time) {
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(time / (1000 * 60 * 60 * 24));
      var hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((time % (1000 * 60)) / 1000);
      let timeString = '';
      // Output the result in an element with id="demo"
      if (days > 0) {
        timeString =
          'เหลือเวลาอีก ' +
          days +
          ' วัน ' +
          hours +
          ' ชั่วโมง ' +
          minutes +
          ' นาที ' +
          seconds +
          ' วินาที ';
      } else if (hours > 0) {
        timeString =
          'เหลือเวลาอีก ' +
          hours +
          ' ชั่วโมง ' +
          minutes +
          ' นาที ' +
          seconds +
          ' วินาที ';
      } else if (minutes > 0) {
        timeString =
          'เหลือเวลาอีก ' + minutes + ' นาที ' + seconds + ' วินาที ';
      } else {
        timeString = 'เหลือเวลาอีก ' + seconds + ' วินาที ';
      }
      return timeString;
    },
    async uploadFile(file) {
      let ticket = generateVodTicket();
      var timeStarted = new Date();
      let formData = new FormData();
      /*
            Add the form data we need to submit
          */
      formData.append('file', file);
      formData.append('title', file.name);
      // formData.append('image', file);
      formData.append('time', this.duration);
      formData.append('ticket', ticket);
      /*
            Make the request to the POST /single-file URL
          */
      await axios
        // .post(`${domain}/uploadfile/private/video/ondemand`, formData, {
        .post(`${fileServerEndpoint}/uploadfile/video`, formData, {
          // .post(`http://103.131.203.201:5080/LiveApp/rest/v2/vods/create?name=${file.name}`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.percent =
              parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              ) + '%';
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );

            let timeElapsed = new Date() - timeStarted;
            let uploadSpeed = progressEvent.loaded / timeElapsed; // Upload speed in millisecond

            // `callback` is the function that shows the time to user.
            // The only argument is the number of remaining seconds.
            this.timeLeft = this.timeToString(
              (progressEvent.total - progressEvent.loaded) / uploadSpeed
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.videoUploadId = response.data.result;
            let resultLink = await getPrivateVideo(this.videoUploadId);
            if (resultLink.isCheckComplete !== undefined) {
              this.isCheckComplete = resultLink.isCheckComplete;
              this.antMediaServer = true;
              if (resultLink.isCheckComplete) {
                this.urlVideo = resultLink.url;
                this.playerOptions.sources[0] = {
                  src: resultLink.url,
                  type: 'application/x-mpegURL',
                };
              } else {
                // this.playerOptions.sources[0].src =
                //   resultLink.urllocalhost +
                //   `?token=${localStorage.getItem(
                //     "x-session-token"
                //   )}&server=${serverName}`;

                this.playerOptions.sources[0] = {
                  src: resultLink.urllocalhost,
                  type: 'application/x-mpegURL',
                };
                this.urlVideo = resultLink.urllocalhost;
              }
              this.successUpload = true;
              this.pendingUpload = false;
            } else {
              this.showUploadPercent = false;
              this.cantGetLink = true;
              this.pendingUpload = false;
            }

            await this.validate();
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!');

          let msg = 'Can not upload video';
          if (e.response != null && e.response.data != null) {
            msg = e.response.data.message;
          }

          EventBus.$emit('snackbar', {
            text: msg,
            dark: true,
            centered: true,
            color: 'error',
          });
        });
    },
    checkToSave() {
      try {
        $('video').get(0).pause();
      } catch (e) {
        console.log('video player not found');
      }
      if (this.lectureId) {
        this.title !== this.oldValue.title ||
        this.description !== this.oldValue.description ||
        this.videoFile
          ? (this.warnningToSaveDialog = true)
          : ((this.isCheckComplete = false), this.closeLectureDialog());
      } else {
        this.title || this.description || this.videoFile
          ? (this.warnningToSaveDialog = true)
          : ((this.isCheckComplete = false), this.closeLectureDialog());
      }
    },
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  border-radius: 50px;
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.labelExplan {
  text-align: justify;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */

/* video */
.video-js[tabindex='-1'] {
  width: 100%;
  height: 400px;
}
.videoContainer {
  width: 100%;
  /* height: 400px; */
  margin: 0 auto;
}
@media (max-width: 500px) {
  .videoContainer {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
}
/* .vjs_video_3{
  width: 200px;
  height: 200px;
} */
.progressContainer {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  margin-top: -160px;
  margin-bottom: 160px;
}
.progressContainerError {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  margin-top: -180px;
  margin-bottom: 160px;
}

/* @media (max-width: 760px) {
  .progressContainer {
    width: 200px;
  }
} */
.videoPlayer {
  width: 100%;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
@media (max-width: 760px) {
  .videoPlayer {
    width: 100%;
  }
}
@media (max-width: 760px) {
  .select-type-upload ul li {
    margin: 0 20px;
  }
}
@media (max-width: 375px) {
  .select-type-upload ul li {
    margin: 0 10px;
  }
}
@media (max-width: 360px) {
  .select-type-upload ul li {
    margin: 0 10px;
  }
}
@media (max-width: 320px) {
  .select-type-upload ul li {
    margin: 0 1px;
  }
}

.vs-progress--background {
  width: 100%;
}
.input-group {
  display: table;
  margin: 0 auto;
}
.input-upload {
  display: table-cell;
}
.uploadfile {
  display: none;
}
.input-group-btn {
  background-color: #ec407a;
  border-color: #ec407a;
  color: #fff;
  margin-left: -2px;
  border-radius: 0;
  width: 60px;
  padding: 0.75rem 0rem !important;
}
.vs-con-input-label {
  width: 400px;
}
.timeLeft {
  text-align: right;
}
.vjs_video_3-dimensions {
  width: 100% !important;
  height: 320px;
}
.upload_description {
  font-size: 12px;
  color: grey;
  margin-top: 5px;
}

@media (max-width: 800px) {
  .resonsive-iframe {
    height: 500px;
  }
}
</style>
